import { createSlice } from "@reduxjs/toolkit";
import { saveEmployee } from "services/employee/employee";

const initialState = {
    employee : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const saveEmployeeSlice = createSlice({
    name: 'save employee',
    initialState,
    extraReducers: {
        [saveEmployee.pending]: (state) => {
            state.employee.isLoading = true;
        },
        [saveEmployee.fulfilled]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = true;
            state.employee.data = payload;
        },
        [saveEmployee.rejected]: (state, { payload }) => {
            state.employee.isLoading = false;
            state.employee.isSuccess = false;
            state.employee.errorMessage = payload
        }
    }
})
export default saveEmployeeSlice.reducer;